import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HoverButtonContainer = styled.span`
  display: flex;
  opacity: 0;
  align-items: center;
  height: 100%;
  padding-left: ${Spacing.S40};
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(to right, transparent 0%, ${Color.White} 50%);
  pointer-events: none;
`

export const BookingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${Spacing.S12} 0 0 0;
  position: relative;

  &:not(:last-child) {
    padding: ${Spacing.S12} 0;
    border-bottom: 1px solid ${Color.Grey100};
  }

  &:hover {
    ${HoverButtonContainer} {
      opacity: 1;
      pointer-events: all;
    }
  }
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`
